import module from 'viaticos/module.js'
import template from './template.html'
import { isDate } from 'lodash'

export class ViaticosSharedViajeCapturaComponent {
  data
  soloLectura
  tipos_viaje = [
    {id: 1, descripcion: 'Nacional'},
    {id: 2, descripcion: 'Extranjero'},
  ]
  onClose
  onSave

  $onInit () {
    if (!this.data) {
      this.data = {}
    }
    if (!isDate(this.data.fecha_inicial)) {
      this.data.fecha_inicial = new Date()
    }
    if (!isDate(this.data.fecha_final) || this.data.fecha_final < this.data.fecha_inicial) {
      this.data.fecha_final = new Date(this.data.fecha_inicial)
    }
  }

  guardar () {
    this.onSave({$event: {detail: this.data}})
    this.cancelar()
  }

  cancelar () {
    this.onClose()
  }
}

module.component('viaticosSharedViajeCaptura', {
  controller: ViaticosSharedViajeCapturaComponent,
  template,
  bindings: {
    data: '<',
    onClose: '&',
    onSave: '&',
    soloLectura: '<',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/viaje/captura/component.js